<template>
    <common-page>
        <div class="card p-1 h-100 overflow-auto">
            <template v-for="(item,index) of groupItems">
                <b-button :key="index" variant="light" @click="currentItem=item">
                    {{ item.name }}
                </b-button>
            </template>
        </div>
        <div class="card p-1 flex-grow-1 ml-1">
            <dictionary-enum-edit v-if="currentItem"
                                  :code="currentItem.code"
                                  :group="getGroup()"
                                  :name-label="currentItem.name"></dictionary-enum-edit>
        </div>
    </common-page>
</template>

<script>
import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import DictionaryEnumEdit from "@/views/common/dictionaryEnum/DictionaryEnumEdit.vue";

const ENTITY = 'emDictData';
export default {
    name: "DictionaryGroupEnumEdit",
    mixins: [emCommonUtilMixin],
    components: {DictionaryEnumEdit, CommonPage},
    data() {
        return {
            groupItems: [],
            currentItem: null,
            queryLoading: false,
            saveLoading: false,
        }
    },
    mounted() {
        this.getRemoteData();
    },
    methods: {
        getGroup() {
            let code = this.$route.params.group;
            if (!this.hasCode(code)) {
                this.$message.warning("Error");
                return false;
            }
            return code;
        },
        getRemoteData() {
            let group = this.getGroup();
            if (group) {
                this.queryLoading = true;
                this.$store.dispatch('api/get', {
                    url: `${this._baseUrl(ENTITY)}/simple/group/${group}/queryItems`
                }).then(res => {
                    this.groupItems = res;
                    if (res && res.length > 0) {
                        this.currentItem = res[0];
                    }
                }).finally(() => this.queryLoading = false);
            }
        },
    }
}
</script>

<style scoped>

</style>
